import "./Attributes.css";

import Img1 from "./images/img1.webp";
import Img2 from "./images/img2.webp";
import Img3 from "./images/img4.webp";

const Attributes = () => {

    return (<div className="attributes-main" >

        <div className="am-1" >
            <h4>We focus on one <span>impactful</span> lesson at a time</h4>
            <h2>Shaping the <span>future</span> of kids</h2>
        </div>

        <div className="am-2" >

            <div className="am-2-sub" >
                <img className="attr-img-1" alt="attribute" src={Img1} />
                <h4>Practical Learning</h4>
                <p>I learn by doing</p>
            </div>


            <div className="am-2-sub" >
                <img className="attr-img-2" alt="attribute" src={Img2} />
                <h4 className="attr-h4-2" >Freedom to Explore</h4>
                <p className="attr-p-2"  >I discover things everyday</p>
            </div>


            <div className="am-2-sub" >
                <img alt="attribute" src={Img3} />
                <h4>Fun with purpose</h4>
                <p>Every activity helps me grow</p>
            </div>

        </div>

    </div>)

}

export default Attributes;